module.exports = __webpack_public_path__ + "img/answer.d8fe5deb.svg";